import { NumberUtils } from './../../utils/number-utils';

/**
 * A dataservice that performs external refund operations
 */
export class ExternalRefundsService {
  public externalRefundResource: InterACT.Interfaces.IResource<InterACT.Interfaces.ChargeAccounts.ExternalRefundResponse>;

  constructor($resource) {
    this.externalRefundResource = $resource('api/external-refunds/:id')
  }

  /**
   * Creates a new external refund
   *
   * @param externalRefund An object representation of an external refund to be created
   *
   * @returns A promise that resolves once the POST operation is complete
   */
  public createExternalRefund(externalRefund: InterACT.Interfaces.ChargeAccounts.ExternalRefund) {
    return this.externalRefundResource.save(externalRefund).$promise;
  }


  /**
   * Get an external refund by id
   *
   * @param id the id of the external refund to retrieve
   *
   * @returns A promise that resolves with the external refund
   */
  public getExternalRefund(id: string) {
    return this.externalRefundResource.get({ id: id }).$promise;
  }

  /**
   * A method that returns a new external refund object using the supplied arguments
   * @param shopTopUpData the topup data recorded by the shop / external party
   * @param balanceAdjustment the balance adjustment that the refund relates to
   **/
  public getNewExternalRefund(shopTopUpData: InterACT.Interfaces.ITopupData,
    balanceAdjustment: InterACT.Interfaces.ChargeAccounts.BalanceAdjustment): InterACT.Interfaces.ChargeAccounts.ExternalRefund {
    return {
      scheme: balanceAdjustment.scheme,
      balanceAdjustment: {
        link: '/balance-adjustments/' + balanceAdjustment.id
      },
      status: 'PENDING',
      shopName: shopTopUpData.shopName,
      amount: NumberUtils.round(shopTopUpData.amount)
    }
  } 
}